import React, { useEffect, useState } from 'react'
import { InMemoryCache, ApolloClient, gql } from '@apollo/client'
import { Layout, Form, Select, Button, Progress, Modal } from 'antd'
import { each } from 'awaity/esm'

const cache = new InMemoryCache()
const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_URI,
  cache,
})

const GET_EVENTS = gql`
  {
    events(sort: _ID_DESC) {
      _id
      slug
      title
    }
  }
`

const GET_TIMES = gql`
  query getTimes($slug: String!){
    times(
      filter: { 
        slug: $slug
      },
      sort: _ID_ASC
    ) {
      _id
      name
      bib
      race
      slug
      gunTime
    }
  }
`

const MUTATION_RE_GENERATE = gql`
  mutation reGenerate($record: TimeInput) {
    reGenerateEcer(record: $record) {
      _id
      bib
      name
      race
      slug
    }
  }
`

function ReGenerate() {
  const [events, setEvents] = useState([])
  const [times, setTimes] = useState([])
  const [progressGenerating, setProgressGenerating] = useState(0)
  const [loadingTime, setLoadingTime] = useState(false)
  useEffect(() => {
    async function init() {
      const { data } = await client.query({ query: GET_EVENTS })
      setEvents(data.events)
    }
    init()
  }, [])

  const handleReGenerate = async () => {
    await each(times, async ({
      _id, name, bib, race, gunTime, slug,
    }, index) => {
      const record = {
        _id, name, bib, race, gunTime, slug,
      }

      try {
        const { data: { reGenerateEcer } } = await client.mutate({ mutation: MUTATION_RE_GENERATE, variables: { record } })
        console.log('generate success', reGenerateEcer)
        setProgressGenerating(((index + 1) * 100) / times.length)
      } catch (e) {
        console.error(e)
      }
    })
    Modal.success({
      title: 'Generate success !!!!',
      content: 'Working Smarter, Not Harder. By Kevin eiei 🐼',
      onOk: () => window.location.reload(),
    })
  }

  if (events.length === 0) return <div>loading events...</div>

  return (
    <Layout style={{ backgroundColor: '#fff' }}>
      <Layout.Content
        style={{
          width: '60%', margin: 'auto', marginTop: 20, backgroundColor: '#fff',
        }}
      >
        <h1 >Re Generate page.</h1>
        <Form>
          <Form.Item label="Event">
            <Select
              showSearch
              onChange={async (slug) => {
                setLoadingTime(true)
                const { data: { times: dataTime }, loading } = await client.query({ query: GET_TIMES, variables: { slug } })
                setLoadingTime(loading)
                setTimes(dataTime)
              }}
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {events.map(event => (
                <Select.Option
                  key={event._id}
                  value={event.slug}
                >{event.title}
                </Select.Option>
                    ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              disabled={times.length === 0}
              onClick={handleReGenerate}
            >
              {`Generate ${times.length} item`}
            </Button>
          </Form.Item>
        </Form>
        {loadingTime && <span>loading data</span>}
        <Progress percent={progressGenerating} status="active" />
      </Layout.Content>
    </Layout>
  )
}

export default ReGenerate



// WEBPACK FOOTER //
// ./src/CreateEcer/ReGenerate.js